<template>
  <div id="app" class="app">
    <overlay v-if="$store.getters['global/isOverlayShown']" />
    <modal></modal>
    <Header v-if="$route.meta.requiresAuth" />
    <div class="main">
      <template v-if="$route.name">
        <router-view></router-view>
      </template>
      <template v-else>
        <loader />
      </template>
    </div>
  </div>
</template>

<script>
import Header from '@/layout/Header.vue'
import Loader from '@/layout/Loader.vue'
import Modal from '@/layout/Modal.vue'
import Overlay from '@/layout/Overlay.vue'

import pageTitleNotification from '@/components/flash-title'

const flashTitle = pageTitleNotification()

export default {
  name: 'app',
  components: { Header, Modal, Loader, Overlay },
  computed: {
    action () {
      return this.$store.getters['global/getAction']
    },
    hasError () {
      return this.$store.state.global.errorMsg
    }
  },
  watch: {
    'hasError' (newValue) {
      if (newValue === true) {
        this.$store.commit('global/updateAction', 'error-msg')
        this.$store.commit('global/updateModalShown')
      }
    }
  },
  created () {
    // register the custom store
    import(`@/custom/${process.env.VUE_APP_CUSTOM}/store/custom`).then((module) => {
      const storeCustom = module.default
      this.$store.registerModule('custom', storeCustom)
    })
    const that = this
    window.addEventListener('blur', () => {
      that.$store.commit('user/updateIsAllowedToPush', true)
      // console.log('BLUR', that.$store.getters['user/isAllowedToPush'])
    })
    window.addEventListener('focus', () => {
      that.$store.commit('user/updateIsAllowedToPush', false)
      // console.log('FLASH FOCUS', flashTitle, flashTitle.isInit)
      // const flashTitle = pageTitleNotification()
      // if (flashTitle.isInit === true) {
      flashTitle.off()
      // }
    })
    window.setInterval(() => {
      that.$store.dispatch('user/getHeaderStats')
    }, 5 * 60 * 1000)
  }
}
</script>

<style lang="scss">
@import "./reboot.scss";
@import "./assets/scss/global.scss";

body {
  background: #f2f8ff;
  color: $default-color;
  margin: 0;
  // overflow: hidden;
}

.app {
  font-family: 'Nunito', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  h1 {
    font-size: 2rem;
    margin: .75rem 0;
  }

  h2 {
    font-size: 1.6rem;
    margin: .5rem 0;
  }

  h3 {
    font-size: 1.25rem;
    margin: .35rem 0;
  }

  input[type="text"], input.gmap-search, textarea, select {
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #cacfe7;
    border-radius: .25rem;
    color: $default-color;
    height: calc(2.75rem + 2px);
    outline: none;
    padding: .65rem 1rem;

    &:focus {
    //   color: #57608b;
    //   background-color: #fff;
    //   border-color: $highlight-color;
      outline: none;
    }
  }

  textarea {
    height: auto;
  }

  .alert {
    background: silver;
    border-radius: .35rem;
    padding: 1rem;
    text-align: left;

    &.alert-danger {
      background: $alert-color;
      color: #fff;

      .btn {
        background: rgba(0,18,78,.25);
        border: none;
      }
    }
  }

  .btn {
    align-items: center;
    background-color: $highlight-color;
    border: 1px solid $highlight-color;
    border-radius: 25rem;
    color: #fff;
    cursor: pointer;
    display: block;
    font-size: .8rem;
    font-weight: 700;
    justify-content: center;
    margin: 1.5rem;
    padding: .6rem .85rem;
    outline: none;
    text-decoration: none;

    &[disabled] {
      opacity: .5;
      cursor: default;
    }

    & svg {
      margin: 0 0 0 -5px;
      position: static;
    }

    &.btn-big {

    }

    &.btn-danger {
      background: $alert-color;
      border: 1px solid $alert-color;
      color: #fff;
    }

    &.btn-dark {
      background: rgb(69, 99, 203);
    }

    &.btn-inline {
      display: inline-block;
      margin: 0;
    }

    &.btn-inverse {
      background-color: #fff;
      color: $highlight-color;

      &:hover {
        color: #fff;
        background-color: $default-color;
        border-color: $default-color;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
      }
    }

    &.btn-small {
      font-size: .75rem;
      margin: 0 .25rem;
      padding: .3rem .85rem;
    }

    &.btn-squared {
      border-radius: .25rem;

      &.btn-40px {
        height: 40px;
        width: 40px;
      }
    }

    &.btn-transparent {
      background: none;
      border:none;
      border-radius: 0;
    }
  }

  .options-menu-wrapper {
    position: relative;
    display: inline-block;

    .arrow-box {
      position: relative;
      background: #FFF;
      border: 1px solid #c2e1f5;

      &:after, :before {
        top: 100%;
        left: 25px;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }

      &:after {
        border-color: rgba(255, 255, 255, 0);
        border-top-color: #FFF;
        border-width: 10px;
        margin-left: -10px;
      }

      &:before {
        border-color: rgba(194, 225, 245, 0);
        border-top-color: #c2e1f5;
        border-width: 11px;
        margin-left: -11px;
      }
    }

    .options-menu {
      background: #fff;
      border: 1px solid #e4e5ec;
      border-radius: .35rem;
      box-shadow: 0 5px 75px 2px rgba(64,70,74,.2);
      position: absolute;

      ul {
        list-style: none;
        margin: 0;
        padding: 5px 0;
        width: 100%;

        li {
          width: 100%;

          a, button {
            background: #fff;
            border: none;
            color: #57608b;
            display: block;
            font-size: 0.9rem;
            padding: 8px 12px;
            text-align: left;
            text-decoration: none;
            width: 100%;
            white-space: nowrap;

            &:hover {
              text-decoration: none;
              background-color: #f9fafd;
            }

            &:active {
              outline: none;
            }
          }

          svg {
            transform: scale(0.5);
          }
        }
      }
    }
  }

  .panel {
    background: #fff;
    border-radius: 0.35rem;
    box-shadow: 0 20px 25px 0 rgba(43,101,144,.1);
    display: flex;
    flex-direction: column;
    margin: 1rem;

    &:first-child {
      margin-top: 0rem;
    }

    &:last-child {
      margin-bottom: 2rem;
    }

    h1 {
      color: $highlight-color;
      font-weight: 700;
      font-size: 1.25rem;
      margin: 0;
      padding: 1.5rem 1.5rem .5rem 1.5rem;
    }

    h2 {
      background: $highlight-color;
      border-bottom: 1px solid rgba(86,95,138,.2);
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      color: #fff;
      font-weight: 700;
      font-size: 1.15rem;
      margin: 0;
      padding: 1rem 1.5rem 1rem 1.5rem ;
    }

    h2:last-child {
      border-bottom: none;
    }

    h3 {
      border-bottom: 1px solid rgba(86,95,138,.2);
      margin: 0rem !important;
      padding: 1.25rem 1.5rem;
    }

    ul {
      display: flex;
      flex-direction: column;
      list-style-type: none;
      margin: 0rem ;
      padding: 0;

      li {
        margin: 0;
        padding: 0;

        a {
          display: block;
          margin: .5rem 1.5rem 1.5rem 1.5rem;
          padding: 0;
          text-decoration: none;
        }

        h3 {
          margin: 1.5rem;
          // padding: 0;
        }
      }
    }

    ul ul {
      margin: 1rem  0rem  0rem 0rem ;
    }
  }
}

.main {

  * {
    box-sizing: border-box;
    font-size: 1rem;
  }

  .feather {
    width: 20px !important;
    height: 24px !important;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
  }

  > div {
    display: flex;
    width: 100%;

    .content {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 190px);
      margin: 1rem 0;
      width: 50%;

      @media screen and (min-width: $break-large) {
        width: 40%;
      }

      &> div {
        width: 100%;
      }
    }

    .details {
      display: flex;
      margin: 1rem 0;
      width: 25%;

      @media screen and (min-width: $break-large) {
        width: 40%;
      }
    }

    .nav {
      border-right: 1px solid rgb(228, 231, 237);
      display: flex;
      flex-direction: column;
      height: calc(100vh - 190px);
      overflow-x: hidden;
      overflow-y: auto;
      margin: 1rem 0;
      min-width: 225px;
      width: 25%;

      @media screen and (min-width: $break-large) {
        width: 20%;
      }
    }

    .well {
      background: #fff;
      box-shadow: 0 10px 18px 0 rgba(62, 57, 107, .2);
      height: auto;
      padding: 20px;

      h1 {
        font-size: 2rem;
        text-align: center;
      }
    }
  }
}

.highcharts-label.highcharts-tooltip > span > span + br + span {
  display: none !important;
}

.highcharts-legend-item span {
  font-size: .85rem !important;
  font-weight: normal !important;
}
</style>
